import { Provider } from 'react-redux';
import './App.css';
import Alert from './components/Alert/Alert';
import CTAModal from './components/Modal/CTAModal';
import AppRoutes from './routes/AppRoutes';
import store from './store/store';
import Loader from './components/loader/Loader';
import { BrowserRouter } from 'react-router-dom';
import CTACall from './components/Modal/CTACall';

const App = () => {

  return (
    <div className="App">
      <Provider store={store}>
        <CTACall />
        <CTAModal />
        <Alert />
        <Loader />
        <BrowserRouter basename='/'>
          <AppRoutes />
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
